export enum EnumSCMComponent {
    Labour = 1,
    Overhead = 2,
    SpecialDirectCost = 3,
    LocalCosts = 4,
    MaterialOverhead=5,
    LabourOverhead=6,
    SpecialDirectCosts=7
}
